<div class="order-component">
  <nz-spin [nzTip]="'LOADING' | translate" [nzSpinning]="isSpinning">
    <div class="statistic-wrap gap-8 mb-8 flex sm:flex-col">
      <div *ngFor="let data of chartData;let i = index;"  class="statistic" [ngClass]="{ 'hover:bg-purpleBg': i==0, 'hover:bg-yellow100': i==1, 'hover:bg-green100': i==2}" [style.border-top]="'6px solid ' + data.color" (click)="handleStatus(data.status)">
        <div>
          <p [style.color]="data.color" class="font14-w500">{{ data.label }}</p>
          <p><span class="font-bold font18-w700">{{ data.value }}</span><span class="lines">({{'ORDERS' | translate}})</span></p>
        </div>
      </div>
    </div>
  <form [formGroup]="searchFormData">
    <div class="flex w-full flex-wrap gap-x-4 sm:flex-col">
      <div class="sm:w-full mx:w-[556px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <div class="flex">
              <div class="mx:w-[270px]">
                <nz-select class="bosch-select" formControlName="keywordsType" (ngModelChange)="changeKeywords()" [nzSuffixIcon]="suffixSearch">
                  <nz-option *ngFor="let item of codeTypeList; let i = index" [nzValue]="item.value"
                    [nzLabel]="item.name"></nz-option>
                </nz-select>
                <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
              </div>
              <div class="mx:w-[270px] ml-4">
                <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input">
                  <input (keydown.enter)="onInputEnter($event)"  nz-input type="text" formControlName="keywords" [placeholder]="(searchFormData.get('keywordsType')?.value === 'orderedMaterialNumber'?('PLACEHOLDER_MATERIAL' | translate):('PLEASE_INPUT' | translate))" />
                  <ng-template #suffixTemplateInfo>
                    <i class="search" (click)="handleChange($event)"></i>
                  </ng-template>
                </nz-input-group>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[270px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <nz-select class="bosch-select" [nzOptionHeightPx]="142" [nzOptionOverflowSize]="2" nzShowSearch [nzFilterOption]="filterOption"  formControlName="shipTo" nzAllowClear [nzPlaceHolder]="'CART_SHIPPING_ADDRESS' | translate" (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixSearch">
              <nz-option nzCustomContent [nzLabel]="shippingAddress.customerName" [nzValue]="shippingAddress" *ngFor="let shippingAddress of shippingAddressList">
                <div class="adrress-item">
                  <p class="font16-w700">{{shippingAddress.customerName}}</p>
                  <p class="font16-w500">{{shippingAddress.street}}</p>
                  <p class="font16-w500">{{shippingAddress.postalCode}} {{shippingAddress.city}}</p>
                  <p class="font16-w500">{{shippingAddress.country}} {{shippingAddress.region}}</p>
                  <p class="font16-w500">{{shippingAddress.mobilePhone}}</p>
                  <p class="font16-w500">{{shippingAddress.customerCode}}</p>
                </div>
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[270px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <nz-range-picker class="w100 bosch-date-picker " [nzRanges]="ranges" [nzSuffixIcon]="suffixDate" formControlName="orderDate" (ngModelChange)="handleChange($event)"></nz-range-picker>
            <ng-template #suffixDate><i class="search-date"></i></ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[270px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <nz-select class="bosch-select" formControlName="orderStatusList" (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixSearch"
            nzMode="multiple"  [nzMaxTagCount]="1" [nzShowSearch]="false" nzAllowClear [nzShowArrow]="true" [nzPlaceHolder]="'ORDER_STATUS' | translate">
              <nz-option nzValue="Open" [nzLabel]="'OPEN' | translate"></nz-option>
              <nz-option nzValue="Being Processed" [nzLabel]="'BEING_PROCESSED' | translate"></nz-option>
              <nz-option nzValue="Credit blocked" [nzLabel]="'CREDIT_BLOCKED' | translate"></nz-option>
              <nz-option nzValue="Completed" [nzLabel]="'COMPLETED' | translate"></nz-option>
              <nz-option nzValue="Cancelled" [nzLabel]="'CANCELLED' | translate"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[270px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <nz-select class="bosch-select" formControlName="orderTypeList" (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixSearch"
              [nzMaxTagCount]="1" [nzShowSearch]="false" nzAllowClear [nzShowArrow]="true" [nzPlaceHolder]="'ORDER_TYPE_FILTER' | translate">
              <nz-option *ngFor="let item of orderTypeFilterList" [nzValue]="item.value" [nzLabel]="item.label"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[270px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <nz-select class="bosch-select" formControlName="sortType" (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixSearch">
              <nz-option *ngFor="let item of sortList; let i = index" [nzValue]="item.value" [nzLabel]="item.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full sm:mb-4 mx:w-[104px] flex" >
        <button nz-button nzType="text" class="clear flex justify-center"  (click)="clear()" [nzLoading]="exportLoading">
          <svg-icon [iconName]="'new/close-blue.svg'" [size]="20" ></svg-icon> {{"CLEAR" | translate}}
        </button>
      </div>
    </div>
  </form>
  <div class="result-table">
    <nz-table [nzFrontPagination]="false" #fixedTable [nzScroll]="{ x: 'max-content' }"
    nzShowPagination [nzData]="OrderData" [nzTotal]="pagination.total"
      [nzPageIndex]="pagination.pageIndex" [nzPageSize]="pagination.pageSize"
      [nzPageSizeOptions]="pagination.pageSizeOptions" (nzPageIndexChange)="pageIndexChange($event)"
      (nzPageSizeChange)="pageSizeChange($event)">
      <thead>
        <tr>
          <th nzWidth="150px">{{"ORDER_NO" | translate}}</th>
          <th nzWidth="150px">{{"PO_No" | translate}}</th>
          <th nzWidth="150px">{{"CART_PROCESS_ORDER" | translate}}</th>
          <th nzWidth="150px">{{"SOLD_TO_NO" | translate}}</th>
          <th nzWidth="150px">{{"ORDER_DATE" | translate}}</th>
          <th nzWidth="180px"> {{"GROSS_VALUE" | translate}}</th>
          <th nzWidth="180px">{{"ORDER_STATUS" | translate}}</th>
          <th nzWidth="150px">{{"COMPLETED_ITEMS" | translate}}</th>
          <th nzWidth="150px">{{"UPDATE_TIME_ORDER" | translate}}</th>
          <th nzRight nzWidth="140px">{{"ACTION" | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of OrderData">
          <td>
            <div class="link" (click)="goPage('order/detail',data.orderNo)">{{data.orderNo}}</div>
          </td>
          <td> <div class="po_number">{{data.poNo}}</div></td>
          <td>
            {{data.orderTypeDisplayName}}
          </td>
          <td> <div class="po_number">{{data.customerId}}</div></td>
          <td>{{ data.orderCreateDate }}</td>
          <td><span *ngIf="data.totalAmount">{{data.currency}} {{data.totalAmount | number : "1.2-2" }}</span> <svg-icon *ngIf="data.totalAmount" [iconName]="'new/arrow.svg'" class="ml-2" nz-popover [nzPopoverPlacement]="'top'"
            [nzPopoverContent]="priceTemplate" [size]="10"></svg-icon></td>
          <td>
            <custom-tag [content]="data.realOrderStatusDisplayName" [backgroundColor]="getColorByStatus(data.realOrderStatus,true,false)" [fontColor]="getColorByStatus(data.realOrderStatus,false,false)" [borderColor]="getColorByStatus(data.realOrderStatus,false,true)"></custom-tag>
          </td>
          <!-- <nz-progress class="progress" [nzPercent]="getPercent(data.totalCompletedQuantity,data.totalOrderQuantity)" [nzShowInfo]="false"></nz-progress> -->
          <td><div class="flex"><span>{{data.totalCompletedQuantity}} / {{data.totalOrderQuantity}}</span></div></td>
          <td>{{data.batch}}</td>
          <td nzRight>
            <svg-icon [title]="'ORDER_DETAIL'| translate" [iconName]="'new/document.svg'" class="mr-2 cursor-pointer"  (click)="goPage('order/detail',data.orderNo)"></svg-icon>
            <svg-icon [title]="'ORDER_AGAIN' | translate"  [iconName]="'new/order-cart-add.svg'" class="mr-2 cursor-pointer"  (click)="orderAgain(data.orderItemInfoVOList)"></svg-icon>
            <!-- <svg-icon [iconName]="'new/download_c.svg'" [title]="'EXPORT' | translate" (click)="exportExcel(data.orderNo)" class="mr-2 cursor-pointer"></svg-icon> -->
            <svg-icon [title]="'CANCEL_ORDER'| translate" [size]="20" [iconName]="'new/digi_cancel.svg'" class="cursor-pointer"  *ngIf="data.canCanCel && isDealerPortal" (click)="handleCancel(data)"></svg-icon>
          </td>
          <ng-template #priceTemplate>
            <div class="price-info">
              <div class="flex">
                <span class="price-info-title"> {{'CART_TOTAL_VALUE' | translate}}: </span>
                <span class="color-blue">{{data.currency}} {{(data.totalAmount | number: '1.2-2')  || '--'}}</span>
              </div>
              <div class="flex">
                <span class="price-info-title ">{{'NET_VALUE' | translate}}:</span>
                <span class="color-grey">{{data.currency}} {{(data.netValue | number: '1.2-2')  || '--'}}</span>
              </div>
              <div class="flex">
                <span class="price-info-title">{{'TAX' | translate}}:</span>
                <span class="color-grey">{{data.currency}} {{(data.taxAmount | number: '1.2-2')  || '--'}}</span>
              </div>
            </div>
          </ng-template>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #totalTemplate let-total>{{
      "TOTAL_ITEM" | translate : { total }
    }}</ng-template>
  </div>
  <nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitle" [nzClosable]="false" (nzOnCancel)="isVisible=false" (nzOnOk)="cancelOrder()">
    <ng-template #modalTitle>
      <div class="flex justify-between">
        <span class="font-bold text-base">{{'CANCEL_ORDER'| translate}}</span>
        <svg-icon [iconName]="'new/close.svg'" class="cursor-pointer fr" (click)="isVisible=false"></svg-icon>
      </div>
      
    </ng-template>
    <ng-container *nzModalContent>
      <p class="my-6">{{'CONFIRM_ORDER_CANCELLATION' | translate}}</p>
    </ng-container>
  </nz-modal>
</nz-spin>
</div>
